module.exports = __webpack_public_path__ + "img/consejos.9293fdae.png";